module.exports = __webpack_public_path__ + "img/cheapsell.a7d32aca.svg";